import { useRef, useState } from "react";
import { useForm, } from "react-hook-form";
import { triggerAlert } from './../../utils/commonFunctions'
import { SendBulkCallFiles, SendBulkMakeCalls } from "../../utils/APIClient";
import DataTable, { createTheme } from "react-data-table-component";
import { Offcanvas } from 'react-bootstrap';
import { Link, useNavigate } from "react-router-dom";
import { createThemeData, customStyles } from './../../utils/Constants';
import { getOnlyToken } from '../../utils/commonFunctions';
import axios from "axios";
const BulkCall = () => {
   document.title = "Callingo |  Bulk Calls";
   let url = new URL(window.location.href);
   let params = new URLSearchParams(url.search.slice(1));
   let obj = {};
   for (let pair of params.entries()) {
      obj[pair[0]] = pair[1];
   }

   const id = obj["agentid"];
   const navigate = useNavigate();
   const { register, handleSubmit, formState: { errors }, reset } = useForm();
   const { register: register1, handleSubmit: handleSubmit1, formState: { errors: errors1 }, reset: reset1, getValues: getValues1, setValue: setValue1 } = useForm();
   const [fileDataArray2, setFileDataArray2] = useState([]);
   const dropRef = useRef(null);
   const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB
   const [ExtractedData, setExtractedData] = useState([]);
   const [showPopup, setshowPopup] = useState(false);
   const [loading, setLoading] = useState(false);
   createTheme('solarized', createThemeData, 'dark');

   const columns = [
      {
         name: "Contact Name",
         selector: (row) => row.Name,
         cell: row => row.Name,
      },
      {
         name: "Email",
         selector: (row) => row.Email,
         cell: row => row.Email,
      },
      {
         name: "Phone Number",
         selector: (row) => row['Phone Number'],
         cell: row => row['Phone Number'],
      },
   ]
   const handleDragOver = (e) => {
      e.preventDefault();
      dropRef.current.classList.add("highlight");
   };

   const handleDragLeave = () => {
      dropRef.current.classList.remove("highlight");
   };

   const handleDrop = (e) => {
      e.preventDefault();
      dropRef.current.classList.remove("highlight");
      const file = e.dataTransfer.files[0];
      if (file && file.type.startsWith("image/")) {
         handleFileChange({ target: { files: [file] } });
      }
   };
   const submitFiles = async (data) => {

      try {

         let formData = new FormData();
         formData.append('file', data.file[0]);
         let response = await SendBulkCallFiles(formData);
         if (response.status === 200) {
            setExtractedData([...response.data]);
            triggerAlert('success', '', 'Files Extracted  successfully');
            setFileDataArray2([]);
         }
      } catch (error) {
         console.error("Error submitting files:", error);
      }
      console.log("Files submitted:", data);
   }
   const handleFileChange = (event) => {
      const files = event.target.files;
      const fileslist = Array.from(event.target.files);
      if (!files || files.length === 0) return;
      const oversizedFiles = fileslist.filter(file => file.size > MAX_FILE_SIZE);
      if (oversizedFiles.length > 0) {
         triggerAlert('error', '', `Each file must be under 1MB. Oversized: ${oversizedFiles.map(f => f.name).join(', ')}` || 'Something went wrong');

         event.target.value = '';
         setFileDataArray2([]);
         return;
      }
      console.log("Files selected:", fileslist);
      setFileDataArray2([...fileslist]);
   };
   const [selectedRows, setSelectedRows] = useState([]);
   const [callStatus, setCallStatus] = useState("initiate");
   const handleRowsChange = (state) => {
      const selectedRows = state.selectedRows;
      console.log("Selected Rows:", selectedRows);
      setSelectedRows([...selectedRows])
      // You can perform any action with the selected rows here
   }
   const [makingCall, setMakingCall] = useState(false);

   const onSubmit = async (data) => {
      // Convert scheduled_time to UTC if it exists
      let scheduledTimeUTC = null;
      if (data.call_status === "schedule" && data.scheduled_time) {
         const localDateTime = new Date(data.scheduled_time);
         scheduledTimeUTC = localDateTime.toISOString();
      }

      let request = {
         "users": selectedRows,
         "company": {
            "agent_id": id,
            "target_lead_company": data.target_lead_company,
            "target_company_website": data.target_company_website,
            "target_company_info": data.target_company_info,
            "ai_personality_forge": data.ai_personality_forge,
            "ai_personality_description": data.ai_personality_description,
            "provider": data.provider,
            "provider_model": data.provider_model,
            "voice": data.voice,
            "call_status": data.call_status,
            "scheduled_time": scheduledTimeUTC
         }
      };

      try {
         setMakingCall(true); 
         let response = await SendBulkMakeCalls(request);
         if (response.status === 201) {
            const { created, errors } = response.data;
            
            // Build success message with HTML formatting
            let successMessage = `Bulk Call initiated successfully. ${created.length} calls placed successfully.`;
            
            // Add error information if there are any failed calls
            if (errors && errors.length > 0) {
               successMessage += `<br/><br/><span style="color: red;">Call initiation failed for ${errors.length} number(s):</span>`;
               errors.forEach((error, index) => {
                  const phoneNumber = error.user['Phone Number'];
                  const errorReason = error.error.replace(/\[ErrorDetail\(string='|', code='.*?\'\)\]/g, '');
                  successMessage += `<br/><span style="color: red;">• ${phoneNumber}: ${errorReason}</span>`;
               });
            }
            
            triggerAlert('success', '', successMessage);
            setshowPopup(false);
            navigate('/call_logs');
            setSelectedRows([]);
            setCallStatus("initiate");
            reset1();
         }
      } catch (error) {
         triggerAlert('error', '', error.response?.data?.message || 'Something went wrong');
         console.error(error);
      } finally {
         setMakingCall(false);
      }
   };

   const handleDownloadSample = () => {
      window.location.href = "https://callapi.pranathiss.com/api/agents/download-sample-excel/";
   };
   const handleGenerateInfo = async () => {
      const companyName = getValues1("target_lead_company");
      const companyWebsite = getValues1("target_company_website");

      if (!companyName || !companyWebsite) {
         alert("Please fill in Company Name and Company Website before generating info.");
         return;
      }

      const token = getOnlyToken();
      const config = {
         headers: {
            Authorization: `Bearer ${token}`,
         }
      };

      try {
         setLoading(true);
         const response = await axios.post(
            `/api/agents/company-info-gen/`,
            {
               company_name: companyName,
               company_website: companyWebsite,
            },
            config
         );
         const companyInfo = response.data?.Company_info?.[0]?.company_info;
         if (companyInfo) {
            setValue1("target_company_info", companyInfo);
         } else {
            alert("No company info found in the response.");
         }
      } catch (error) {
         console.error("Error generating company info:", error);
         alert("Failed to generate company info. Please try again.");
      } finally {
         setLoading(false);
      }
   };

   return (
      <>
         <div className="container-fluid">
            <div className="row">
               <div className="col-12">
                  <div className="page-title-box">
                     <h4 className="page-title lh-1 mb-3">Bulk Calls</h4>
                  </div>
               </div>
            </div>
            <div className="row">
               <div className="col-xl-12 col-lg-12">
                  <div className="card mb-0">
                     <div className="card-header pb-0">
                        <div className="row ">
                           <div className="page-title-box  ">
                              {/* <a href="#" className="btn btn-success  mt-0 page-title-right" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><i className=" ri-user-add-line"></i> Create Agent</a> */}
                              <div className="page-title-left">
                                 <div className="app-search">
                                    <h4 className=" text-green mb-0">Craft Ai Masterpiece</h4>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="card-body">
                        <div className="row justify-content-center">
                           <div className="col-xl-6 col-lg-8 col-md-6 col-sm-8">
                              <div className="  mb-0">
                                 <div className="card-body">
                                    <h4 className="text-green text-center">Upload Your File</h4>
                                    <p className="text-center font-size-18 ">Please upload your file below. </p>
                                    <form onSubmit={handleSubmit(submitFiles)} className="" id="myAwesomeDropzone"  >
                                       <label className="dropzone dz-clickable mb-2" style={{ width: "100%" }} onDragOver={handleDragOver}
                                          onDragLeave={handleDragLeave}
                                          onDrop={handleDrop} ref={dropRef} onChange={(event) => handleFileChange(event)}>
                                          <div className="dz-message needsclick">
                                             <i className="fs-36 text-muted ri-upload-cloud-line"></i>
                                             <h4>Drop files here or click to upload.</h4>
                                          </div>
                                          <div className="fallback d-none">
                                             <input name="file" type="file" id="Agentprofile_picture" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" {...register("file", { onChange: (e) => handleFileChange(e), required: true })} />
                                          </div>
                                       </label>
                                       {errors.Agentprofile_picture && <p className='text-danger'>{errors.Agentprofile_picture.message}</p>}
                                       <p className="mt-2 mb-0 text-center">
                                          <span
                                             onClick={handleDownloadSample}
                                             style={{ color: "#3484fdff", textDecoration: "underline", cursor: "pointer", fontWeight: 500 }}
                                          >
                                             Download sample
                                          </span>
                                       </p>
                                       <p className="text-center">Supported file types:  xlsx and csv.</p>
                                       <div className="dropzone-previews mt-3" id="file-previews">
                                          {fileDataArray2.length > 0 && (
                                             <div style={{ marginTop: '20px' }}>
                                                <label>Selected Files:</label>
                                                {fileDataArray2.map((file, idx) => (
                                                   <div key={idx} style={{ marginBottom: '10px' }}>
                                                      <label>{file.name}</label> <br />

                                                   </div>
                                                ))}
                                             </div>
                                          )}

                                       </div>
                                       <div className="d-flex flex-column flex-sm-row justify-content-center gap-2 mt-3 align-items-center">
                                          <button className="btn btn btn-success rounded-pill" type="submit">Extract File</button>
                                       </div>
                                    </form>






                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className="row justify-content-center">
                           <div className="row">
                              <div className="col-12">
                                 <div className="page-title-box">
                                    <div className="page-title-right">
                                       <form className="d-flex">
                                          <button className="btn btn-success ms-2 flex-shrink-0" onClick={() => { selectedRows.length == 0 ? triggerAlert('error', "", "Please select extracted lead data from table") : setshowPopup(true) }} type="button">
                                             <i className="ri-phone-line fs-18"></i> Bulk Call
                                          </button>
                                       </form>
                                    </div>
                                    <h4 className="page-title">Extracted Lead Data :</h4>
                                 </div>
                              </div>
                           </div>


                           <h4 className="text-green"></h4>
                           <div className="table-responsive">
                              <DataTable
                                 columns={columns}
                                 fixedHeader
                                 fixedHeaderScrollHeight="600px"
                                 persistTableHead
                                 data={ExtractedData}
                                 // paginationComponentOptions={paginationComponentOptions}
                                 // paginationServer
                                 // paginationTotalRows={totalRows}
                                 // paginationDefaultPage={currentPage}
                                 // onChangeRowsPerPage={handlePerRowsChange}
                                 // onChangePage={handlePageChange}
                                 // paginationPerPage={perPage}
                                 selectableRows
                                 theme="solarized"
                                 onSelectedRowsChange={handleRowsChange}
                                 customStyles={customStyles}
                              />

                           </div>
                        </div>
                     </div>

                  </div>

               </div>
            </div>

         </div>


         <Offcanvas show={showPopup} onHide={() => setshowPopup(false)} style={{ width: '600px' }} placement="end" >
            <Offcanvas.Header closeButton>
               {/* <Offcanvas.Title>Add New Role</Offcanvas.Title> */}
            </Offcanvas.Header>

            <Offcanvas.Body>
               <form onSubmit={handleSubmit1(onSubmit)}>
                  <div className="row g-2 mb-1">
                     <div className="mb-1 col-md-6">
                        <label className="form-label">
                           Target Company Name <span className="text-danger">*</span>
                        </label>
                        <input
                           type="text"
                           className={`form-control ${errors1.target_lead_company ? "is-invalid" : ""}`}
                           placeholder="Enter Company Name"
                           {...register1("target_lead_company", { required: "Company name is required" })}
                        />
                        {errors1.target_lead_company && <div className="invalid-feedback">{errors1.target_lead_company.message}</div>}
                     </div>

                     <div className="mb-1 col-md-6">
                        <label className="form-label">
                           Target Company Website <span className="text-danger">*</span>
                        </label>
                        <input
                           type="text"
                           className={`form-control ${errors1.target_company_website ? "is-invalid" : ""}`}
                           placeholder="Enter Target Company Website"
                           {...register1("target_company_website", { required: "Website is required" })}
                        />
                        {errors1.target_company_website && <div className="invalid-feedback">{errors1.target_company_website.message}</div>}
                     </div>

                     <div className="mb-1 col-md-12">
                        <div>
                           <div className="d-flex justify-content-start align-items-center mb-2">
                              <label className="form-label mb-0">
                                 Target Company Info <span className="text-danger">*</span>
                              </label>
                              <button
                                 type="button"
                                 className="btn btn-success rounded-pill ms-2 px-3 py-1"
                                 onClick={handleGenerateInfo}
                                 disabled={loading}
                              >
                                 {loading ? (
                                    <>
                                       <span
                                          className="spinner-border spinner-border-sm me-1"
                                          role="status"
                                          aria-hidden="true"
                                       ></span>
                                       Generating...
                                    </>
                                 ) : (
                                    <>
                                       Generate <i className="ri-sparkling-2-line fs-18 ms-1"></i>
                                    </>
                                 )}
                              </button>
                           </div>

                           <textarea
                              className={`form-control ${errors1.target_company_info ? "is-invalid" : ""}`}
                              rows="6"
                              placeholder="Write a company about or Generate with AI"
                              {...register1("target_company_info", { required: "Company info is required" })}
                           ></textarea>
                           {errors1.target_company_info && (
                              <div className="invalid-feedback">
                                 {errors1.target_company_info.message}
                              </div>
                           )}
                        </div>


                     </div>
                  </div>

                  {/* <div className="row g-2">
                     <div className="d-flex flex-column flex-sm-row justify-content-center gap-2 mt-3 align-items-center">
                        <button className="btn btn btn-success rounded-pill">Create your own script</button>
                        <button className="btn-outline-success rounded-pill btn d-flex align-items-center">
                           Lets AI do the Magic <i className="bi bi-magic ms-1 fs-14"></i>
                        </button>
                     </div>
                     <div className="mb-3 col-md-12">
                        <label className="form-label">
                           AI Personality Forge <span className="text-danger">*</span>
                        </label>
                        <input
                           type="text"
                           className={`form-control mb-2 ${errors1.ai_personality_forge ? "is-invalid" : ""}`}
                           placeholder="20250411132048"
                           {...register1("ai_personality_forge", { required: "Forge ID is required" })}
                        />
                        {errors1.ai_personality_forge && <div className="invalid-feedback">{errors1.ai_personality_forge.message}</div>}

                        <label className="form-label">
                           AI Personality Description <span className="text-danger">*</span>
                        </label>
                        <textarea
                           className={`form-control ${errors1.ai_personality_description ? "is-invalid" : ""}`}
                           rows="4"
                           placeholder="AI Personality Description"
                           {...register1("ai_personality_description", { required: "Description is required" })}
                        ></textarea>
                        {errors1.ai_personality_description && <div className="invalid-feedback">{errors1.ai_personality_description.message}</div>}
                     </div>
                  </div> */}

                  <div className="row g-2 mb-3">
                     <div className="mb-2 col-md-6">
                        <label className="form-label">Provider</label>
                        <select className={`form-select ${errors1.provider ? "is-invalid" : ""}`} {...register1("provider", { required: "Provider is required" })}>
                           <option value="">Choose Provider</option>
                           <option value="Twilio">Twilio</option>
                           <option value="Vitel Global">Vitel Global</option>
                           <option value="Varun digital">Varun digital</option>
                        </select>
                        {errors1.provider && <div className="invalid-feedback">{errors1.provider.message}</div>}
                     </div>
                     <div className="mb-2 col-md-6">
                        <label className="form-label">Model</label>
                        <select className={`form-select ${errors1.provider_model ? "is-invalid" : ""}`}
                           {...register1("provider_model", { required: "Provider model is required" })}>
                           <option value="">Choose Model</option>
                           <option value="Deepgram">Deepgram</option>
                           <option value="Eleven Labs">Eleven Labs</option>
                           <option value="GCP">GCP</option>
                        </select>
                        {errors1.provider_model && <div className="invalid-feedback">{errors1.provider_model.message}</div>}
                     </div>
                     <div className="col-md-6">
                        <label className="form-label">Voice</label>
                        <select className={`form-select ${errors1.voice ? "is-invalid" : ""}`}
                           {...register1("voice", { required: "Voice selection is required" })}>
                           <option value="">Choose Voice</option>
                           <option value="Aura-2-(andromeda)">Aura-2-(andromeda)</option>
                           <option value="Aura-2-(apollo)">Aura-2-(apollo)</option>
                           <option value="Aura-2-(apollo)-(masculine)">Aura-2-(apollo)-(masculine)</option>
                        </select>
                        {errors1.voice && <div className="invalid-feedback">{errors1.voice.message}</div>}
                     </div>
                     {/* <div className="col-md-6">
                        <label className="form-label">Call Status</label>
                        <select className={`form-select ${errors1.call_status ? "is-invalid" : ""}`}
                           {...register1("call_status", { required: "Call status is required" })}
                           value={callStatus}
                           onChange={(e) => {
                              setCallStatus(e.target.value);
                              setValue1("call_status", e.target.value);
                           }}>
                           <option value="initiate">Initiate</option>
                           <option value="schedule">Schedule</option>
                        </select>
                        {errors1.call_status && <div className="invalid-feedback">{errors1.call_status.message}</div>}
                     </div> */}
                     {callStatus === "schedule" && (
                        <div className="col-md-12">
                           <label className="form-label">Scheduled Time</label>
                           <input 
                              type="datetime-local" 
                              className={`form-control ${errors1.scheduled_time ? "is-invalid" : ""}`}  
                              {...register1("scheduled_time", { 
                                 required: callStatus === "schedule" ? "Scheduled time is required" : false 
                              })} 
                           />
                           {errors1.scheduled_time && <div className="invalid-feedback">{errors1.scheduled_time.message}</div>}
                        </div>
                     )}
                     {/* <div className="mb-2 col-md-6">
                        <label className="form-label">Scheduled Time</label>
                        <input type="datetime-local" className={`form-control ${errors1.scheduled_time ? "is-invalid" : ""}`}  {...register1("scheduled_time", { required: "Scheduled Time is required" })}  ></input>
                        {errors1.scheduled_time && <div className="invalid-feedback">{errors1.scheduled_time.message}</div>}
                     </div> */}
                  </div>
                  <div className="mb-2 text-center">
                     <button
                        type="submit"
                        className="btn btn-success rounded-pill"
                        disabled={makingCall}
                     >
                        {makingCall ? (
                           <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Placing Calls...
                           </>
                        ) : (
                           "Make Calls"
                        )}
                     </button>
                  </div>

               </form>
            </Offcanvas.Body>

         </Offcanvas>
      </>
   );
}

export default BulkCall;